import IGameAPI from "./api/IGameAPI";
import GameAPI from "./api/GameAPI";
import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import MockAPI from "./api/MockGameAPI";
import URLSearchParams from "@ungap/url-search-params"

export class GameManager {

    static api: IGameAPI;

    public static init(): void {

        GameVars.aspectRatio = window.innerHeight / window.innerWidth;

        if (GameVars.currentScene.sys.game.device.os.desktop) {

            GameVars.scaleY = 1;
            GameVars.aspectRatio = 4 / 3;

        } else {

            GameVars.currentScene.game.scale.displaySize = GameVars.currentScene.game.scale.parentSize;
            GameVars.currentScene.game.scale.refresh();

            GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / GameVars.aspectRatio;
        }

        GameVars.selectedPresent = 1;

        console.log("process.env.api (API type): ", process.env.api);

        const urlParams = new URLSearchParams(window.location.search);
        const customerId = urlParams.get("user_id");

        console.log("URL query string: " + urlParams);
        console.log("Customer id: " + customerId);

        switch (process.env.api) {
            case "proxy":
                console.log("Using proxy API...");
                this.api = new GameAPI("/api", customerId);
                break;
            case "mock":
                console.log("Using mock API...", customerId);
                this.api = new MockAPI(4);
                break;
            default:
                console.log("Using production API...");
                this.api = new GameAPI("https://api.sunlight.net", customerId);
                break;
        }

        if (process.env.testcookie) {
            console.log("Setting test cookie from process.env.testcookie: ", process.env.testcookie);
            document.cookie = process.env.testcookie;
        }

        (async () => {

            console.log("api.init")

            await this.api.init();

            // console.log("api.gameInfo", this.api.gameInfo.content);

            GameVars.gameInfo = this.api.gameInfo.content;

            GameVars.prizeResults = await this.api.fetchPrizes();

            const retryCountResponse = await this.api.fetchRetryCount();

            GameVars.spinsCounter = retryCountResponse.amount;

            GameManager.startGame();
        })();
    }

    static async getData(url = '', data = {}) {

        const response = await fetch(url, {
            method: 'POST',
            mode: 'no-cors',
            credentials: 'include',
            referrerPolicy: 'unsafe-url',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        console.log(response);
        return response;
    }

    public static setCurrentScene(scene: Phaser.Scene): void {

        GameVars.currentScene = scene;
    }

    public static onGameAssetsLoaded(): void {

        GameManager.enterRouletteScene();
        // GameManager.enterInfoScene();
        // GameManager.enterPrizesScene();
        // GameManager.enterPresentInfoScene();
    }

    public static enterRouletteScene(): void {

        GameVars.currentScene.scene.start("RouletteScene");
    }

    public static enterInfoScene(): void {

        GameVars.currentScene.scene.start("InfoScene");
    }

    public static enterPrizesScene(): void {

        GameVars.currentScene.scene.start("PrizesScene");
    }

    public static openDeepLink(link: string): void {

        var win = window.open(link, '_blank');
        win.focus();
    }

    public static enterPresentInfoScene(i: number): void {

        GameVars.selectedPresent = i;

        GameVars.currentScene.scene.start("PresentInfoScene");
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    private static startGame(): void {

        GameVars.currentScene.scene.start("PreloadScene");
    }
}
